import React, { useEffect, useState } from "react";
import {
  callNonStoreApi,
  handleOpenInNew,
  isArrayNullOrUndefined,
} from "../utils/utils";
import { FetchSubdomainClients } from "../utils/ApiEndpoints";
import Loading from "./Loading";
import { AddFlex, CustomText, PrimaryActionButton } from "./reusableStyles";
import { Link } from "@mui/icons-material";
import styled from "styled-components";
import { primaryActionColor } from "../utils/constants";
import { Drawer } from "@mui/material";
import ClientDetailsDrawer from "./ClientDetailsDrawer";

const StyledAddFlex = styled(AddFlex)`
  color: black;
  transition: none;
  /* &:hover {
    color: ${primaryActionColor};
  } */
`;

const ClientCard = ({ client, setForceRefresh }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { name, sub_text, domain } = client.data;
  return (
    <>
      <AddFlex
        padding="15px"
        border="1px solid #ececec"
        borderRadius="8px"
        flexDirection="column"
        style={{ cursor: "pointer", width: "25%", flexShrink: 0 }}
        onClick={() => setOpenDrawer((prev) => !prev)}
      >
        <StyledAddFlex alignItems="center">
          <CustomText fontSize="20px" fontWeight="500" color="inherit">
            {name}
          </CustomText>
          <Link
            onClick={(e) => {
              e.stopPropagation();
              handleOpenInNew(`https://${domain}`);
            }}
            style={{ fontSize: "20px", margin: "0 10px" }}
          />
        </StyledAddFlex>
        <CustomText fontSize="14px" fontWeight="300" color="black">
          {sub_text}
        </CustomText>
      </AddFlex>
      <Drawer
        open={openDrawer}
        anchor="right"
        onClose={() => setOpenDrawer((prev) => !prev)}
        PaperProps={{
          sx: {
            width: "40vw",
          },
        }}
      >
        <ClientDetailsDrawer
          clientDetails={client.data}
          clientId={client.clientId}
          setForceRefresh={setForceRefresh}
        />
      </Drawer>
    </>
  );
};

function Subdomains() {
  const [loading, setLoading] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [list, setList] = useState();
  const [forceRefresh, setForceRefresh] = useState(false);
  useEffect(() => {
    callNonStoreApi(FetchSubdomainClients)
      .then((response) => {
        setList(response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [forceRefresh]);

  return loading ? (
    <Loading />
  ) : (
    <div style={{ padding: "48px", position: "relative" }}>
      {isArrayNullOrUndefined(list) ? (
        <div>No Clients</div>
      ) : (
        <>
          <PrimaryActionButton
            style={{
              maxWidth: "max-content",
              position: "absolute",
              right: "48px",
              top: "30px",
            }}
            onClick={() => setOpenDrawer((prev) => !prev)}
          >
            New
          </PrimaryActionButton>
          <AddFlex wrap="wrap" margin="35px 0 0 0" style={{ gap: "10px" }}>
            {list.map((client) => {
              return (
                <ClientCard client={client} setForceRefresh={setForceRefresh} />
              );
            })}
          </AddFlex>
          <Drawer
            open={openDrawer}
            onClose={() => setOpenDrawer((prev) => !prev)}
            anchor="right"
            PaperProps={{
              sx: {
                width: "40vw",
              },
            }}
          >
            <ClientDetailsDrawer setForceRefresh={setForceRefresh} />
          </Drawer>
        </>
      )}
    </div>
  );
}

export default Subdomains;
